import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getAvailableApplications = api(async function getAvailableApplications() {
    return query(
        gql`
            query getAvailableApplications {
                getAvailableApplications {
                    id
                    name
                    path
                    icon
                    displayName
                }
            }
        `,
        {},
        { returns: "getAvailableApplications" }
    )
})
